import React, {FC} from 'react'
import {Text, View} from '@react-pdf/renderer'
import {JobRequest, ReferenciaPersonal} from '../components/NuevoEmpleoHelper'
interface NuevoEmpleoHelperPDF {
  styles: any
  data?: JobRequest
}
const ReferenciasPersonales: FC<NuevoEmpleoHelperPDF> = ({styles, data}) => {
  return (
    <>
      <View style={{textAlign: 'left', marginTop: 10, marginLeft: 50}}>
        <Text>I. REFERENCIAS PERSONALES</Text>
      </View>
      <View style={styles.table}>
        <View style={styles.tableRow}>
          <View style={{...styles.tableCol, width: '33%'}}>
            <Text style={{...styles.tableCell, textAlign: 'center'}}>Nombre</Text>
          </View>
          <View style={{...styles.tableCol, width: '33%'}}>
            <Text style={{...styles.tableCell, textAlign: 'center'}}>Teléfono (s)</Text>
          </View>
          <View style={{...styles.tableCol, width: '34%'}}>
            <Text style={{...styles.tableCell, textAlign: 'center'}}>Relación</Text>
          </View>
        </View>
        {data?.referenciasPersonales.map(function (value: ReferenciaPersonal, index: number) {
          return (
            <View style={styles.tableRow} key={index + '_ref_per'}>
              <View style={{...styles.tableCol, width: '33%'}}>
                <Text style={{...styles.tableCell, textAlign: 'center'}}>{value.nombre}</Text>
              </View>
              <View style={{...styles.tableCol, width: '33%'}}>
                <Text style={{...styles.tableCell, textAlign: 'center'}}>{value.telefono}</Text>
              </View>
              <View style={{...styles.tableCol, width: '34%'}}>
                <Text style={{...styles.tableCell, textAlign: 'center'}}>{value.relacion}</Text>
              </View>
            </View>
          )
        })}
      </View>
    </>
  )
}
export default ReferenciasPersonales
